import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationItem } from '../../models/college-dashboard.model';
import { CollegeDashboardService } from '../../services/college-dashboard.service';

@Component({
  selector: 'app-college-notifications',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './college-notifications.component.html',
  styleUrl: './college-notifications.component.scss'
})
export class CollegeNotificationsComponent implements OnInit {
  notifications: NotificationItem[] = [];

  constructor(private dashboardService: CollegeDashboardService) {}

  ngOnInit(): void {
    this.dashboardService.notifications$.subscribe((items) => {
      this.notifications = items;
    });
  }

  onMarkAllRead(): void {
    this.dashboardService.markAllNotificationsAsRead();
  }

  onNotificationClick(item: NotificationItem): void {
    this.dashboardService.markNotificationAsRead(item.id);
  }
}
